// ?alert=<id> deep link (FIX-AGENTS-2026-10-12 §7). The last line of every recruiter-agent staff SMS and email is
// https://crm.protherapystaffing.com/?alert=<agent_notifications.id>. This is the CRM half, on the same rules as
// ?conversation= (./conversationDeepLink.js):
//   * the id is read ONLY from that one parameter, only when it is a well-formed UUID; anything else is ignored;
//   * a well-formed id that matches no loaded alert is ignored the same way -- the normal view, never an error;
//   * the parameter is stripped from the address bar once read; the id is never logged.
// Where it lands: an alert on a thread opens that conversation; any other alert opens System alerts on that row
// (with "Show handled", the Low group or the Spam list opened as needed so the row is on screen).
//
// PURE, like the other ./lib modules.
import { isEscalationHandled } from './escalationState';
import { isLowPriority } from './systemAlerts';
import { isRobocallAlert } from './voicemailAlert';

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** The alert id from a location.search string, or null. */
export function parseAlertParam(search) {
  let params;
  try { params = new URLSearchParams(String(search || '')); } catch { return null; }
  const all = params.getAll('alert');
  if (all.length !== 1) return null;
  const id = all[0].trim();
  return UUID.test(id) ? id.toLowerCase() : null;
}

/** The search string with the alert parameter removed ('' or '?a=b'). */
export function withoutAlertParam(search) {
  const params = new URLSearchParams(String(search || ''));
  params.delete('alert');
  const s = params.toString();
  return s ? `?${s}` : '';
}

/**
 * Where the link lands, against what loaded: null (unknown -> normal view), { view: 'conversations',
 * conversationId } for an alert on a thread, or { view: 'alerts', alertId, showHandled, lowOpen, spamOnly }.
 */
export function alertTarget(notifications, id) {
  if (!id) return null;
  const want = String(id).toLowerCase();
  const n = (notifications || []).find((x) => x && String(x.id).toLowerCase() === want);
  if (!n) return null;
  if (n.conversation_id) return { view: 'conversations', conversationId: n.conversation_id };
  return {
    view: 'alerts',
    alertId: n.id,
    spamOnly: isRobocallAlert(n),
    showHandled: isEscalationHandled(n),
    lowOpen: isLowPriority(n),
  };
}
